/** Shared formatting for field GPS display in admin / job UIs. */

export function formatCoordinates(
  lat?: number | null,
  lng?: number | null
): string {
  if (lat == null || lng == null) return '—'
  return `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`
}

export function googleMapsUrl(
  lat?: number | null,
  lng?: number | null
): string | null {
  if (lat == null || lng == null) return null
  return `https://www.google.com/maps?q=${lat},${lng}`
}

/** JobDetails-style embed (no API key). */
export function googleMapsEmbedUrl(
  lat?: number | null,
  lng?: number | null
): string | null {
  if (
    lat == null ||
    lng == null ||
    !Number.isFinite(Number(lat)) ||
    !Number.isFinite(Number(lng))
  ) {
    return null
  }
  return `https://www.google.com/maps?q=${Number(lat)},${Number(lng)}&output=embed`
}

export function formatAccuracyM(accuracy?: number | null): string {
  if (accuracy == null || !Number.isFinite(Number(accuracy))) return '—'
  return `±${Math.round(Number(accuracy))} m`
}
